import { dispatchCustomEvent, getWindowScroll, throttle } from '../../tools/helpers';
import { CONFIG } from '../config';

let eventHandlerScroll = null;

class ScrollHandler {
  constructor() {
    this.timeScroll = 100;
  }

  init() {
    // add handlers
    this.initEventScroll();
  }

  /* =====
   * SCROLL EVENT
   ===== */
  initEventScroll() {
    window.addEventListener('scroll', throttle(() => {
      this.handleEventScroll();
    }, this.timeScroll));
  }

  handleEventScroll() {
    dispatchCustomEvent(
      CONFIG.events.VIEWPORT_SCROLL,
      {
        scroll: getWindowScroll(),
      },
    );
  }
}

// prepare singleton behavior
if (!eventHandlerScroll) {
  eventHandlerScroll = new ScrollHandler();
  eventHandlerScroll.init();
}

export default () => eventHandlerScroll;



// WEBPACK FOOTER //
// ./src/javascript/main/ScrollHandler/index.js